/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const GreaterThanFilesize: core.serialization.ObjectSchema<
    serializers.GreaterThanFilesize.Raw,
    Truvity.GreaterThanFilesize
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace GreaterThanFilesize {
    export interface Raw {
        value: number;
    }
}
